export function notJavascript(string) {
  if (String(string).trim().indexOf('javascript:') === 0) {
    throw new Error('Javascript string not allowed.');
  }

  return string;
}
